import React, { useEffect, useState } from "react";
import clsx from "clsx";
import GenricStpeper from "../../../../Components/OLD/dfmAddEditAndDelete/typePicker/DfmAddEditAndDeleteStepper";
import { CONTACTS } from "../../../../config/pagesName";
import { GetParams } from "../../../../Helper";
import { useLayoutDetection, useTranslate } from "../../../../Hooks";
import {
  CustomSwitch,
  PageTitle,
  QuickAddCorporateView,
  QuickAddIndividualView,
} from "../../../../Components";
import { ContactFormTypeEnum } from "../../../../Enums";

// Styles
import useStyles from "./styles";

function ContactsManagementView() {
  const styles = useStyles();
  const [activeFormType, setActiveFormType] = useState(null);
  const [id, setId] = useState(null);
  const [isQuickAdd, setIsQuickAdd] = useState({
    isIndividual: false,
    isCorporate: false,
  });
  const { isNewLayout: isReskinningLayout, hasNewLayout } =
    useLayoutDetection();
  const isNewLayout = isReskinningLayout && hasNewLayout;

  const { translate } = useTranslate("NewContactsView");

  useEffect(() => {
    setActiveFormType(GetParams("formType"));
    setId(GetParams("id"));
  }, []);

  return (
    <>
      {isNewLayout && (
        <PageTitle
          hideDivider
          title={
            +activeFormType === ContactFormTypeEnum.INDIVIDUAL.value
              ? translate("add-individual-contact-page-title")
              : translate("add-corporate-contact-page-title")
          }
          subTitle={
            +activeFormType === ContactFormTypeEnum.INDIVIDUAL.value
              ? translate("add-individual-contact-page-subtitle")
              : translate("add-corporate-contact-page-subtitle")
          }
          wrapperClasses={styles.pageTitleWrapper}
        >
          <CustomSwitch
            size={"md"}
            label={translate("Quick-Add")}
            checked={
              +activeFormType === ContactFormTypeEnum.INDIVIDUAL.value
                ? isQuickAdd.isIndividual
                : isQuickAdd.isCorporate || false
            }
            onChange={(e) => {
              const isChecked = e.target.checked;
              if (+activeFormType === ContactFormTypeEnum.INDIVIDUAL.value) {
                setIsQuickAdd({
                  isIndividual: isChecked,
                  isCorporate: false,
                });
              } else {
                setIsQuickAdd({
                  isIndividual: false,
                  isCorporate: isChecked,
                });
              }
            }}
            isDisabled={false}
          />
        </PageTitle>
      )}
      <div className={clsx("view-wrapper", { "pt-3": !isNewLayout })}>
        <div className="d-flex-column">
          {isQuickAdd.isIndividual ? (
            <QuickAddIndividualView />
          ) : isQuickAdd.isCorporate ? (
            <QuickAddCorporateView />
          ) : (
            <>
              {activeFormType && (
                <GenricStpeper
                  pageName={CONTACTS}
                  type={activeFormType.toString()}
                  id={(id && +id) || undefined}
                  withTotal
                  isDialog={false}
                  withFormCardWrapper
                />
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}

export { ContactsManagementView };
